// extracted by mini-css-extract-plugin
module.exports = {"container":"_2RfJu9jweRRfwz2lEN2irW","groupsList":"_2laG90ZnXQLfw2aqGj0PXj"};